import Cookies from 'js-cookie'
import store from '../index'

import {deepClone, replaceDocumentIconAndTitle} from '@/utils'
import {getNameCode, removeToken, setToken} from '@/utils/cookie'
import {clearStore, getStore, setStore} from '@/utils/store'

import {loginOut} from '@/api/common/auth/authUser'
import {login as captchaLogin, phoneLogin as phoneCaptchaLogin} from '@/api/common/auth/captcha'
import {formatRoutes, handleRouteByUserRole} from '@/utils/router/other'
import {doctorRoutes, manageRoutes, platformRoutes} from '@/router/routes'
import router from '@/router'
import {getSystemUserInfo} from '@/api/business/user'
import {getTenantInfo} from '@/api/platform/tenant'
import {refreshToken} from '@/api/common/login'
import {getPlatformUserInfo} from '@/api/platform/user'
import {getDoctorInfo} from '@/api/business/doctor'
import {
  findAllHerbs,
  findAllHerbsRestraint,
  optionData,
  findAllSymptoms,
  findAllHisHerbs,
  hisOption, allPrescriptionProject, getUnitConvertConfig
} from '@/api/business/doctor/herbs'
import {getPinyin} from '@/utils/pinyin'
import {getClinicAllFeeConfig} from '@/api/business/doctor/config'

const login = {
  state: {
    access_token: getStore({name: 'access_token'}) || '',
    refresh_token: getStore({name: 'refresh_token'}) || '',
    routes: getStore({name: 'routes'}) || [],
    // 左侧菜单
    menus: getStore({name: 'menus'}) || [],
    // 用户信息
    userInfo: getStore({name: 'userInfo'}) || {},
    // 诊所信息
    clinicInfo: getStore({name: 'clinicInfo'}) || {},
    // 租户信息
    tenantInfo: getStore({name: 'tenantInfo'}) || {},
    tenantConfig: getStore({name: 'tenantConfig'}) || {},
    // 药材信息
    herbsInfo: getStore({name: 'herbsInfo'}) || {},
    // his药材信息
    hisHerbsInfo: getStore({name: 'hisHerbsInfo'}) || {},
    // 药材单位转换配置
    herbUnitConvert: getStore({name: 'herbUnitConvert'}) || [],
    // his项目库
    hisProjectInfo: getStore({name: 'hisProjectInfo'}) || {},
    // 药材克制关系信息
    herbsRestraintInfo: getStore({name: 'herbsRestraintInfo'}) || {},
    // 药材配伍禁忌克制关系的查询索引
    herbsRestraintInfoIndex: getStore({name: 'herbsRestraintInfoIndex'}) || {},
    // 处方配置项（单位、频次、用法配置）
    optionData: getStore({name: 'optionData'}) || {},
    // his 配置项
    hisOption: getStore({name: 'hisOption'}) || {},
    // 症状库
    symptoms: getStore({name: 'symptoms'}) || [],
    // 诊所费用配置
    feeConfig: getStore({name: 'feeConfig'}) || [],
    // 登录类型 normal：普通登录；SSO：单点登录
    loginType: getStore({name: 'loginType'}) || 'normal'
  },
  actions: {
    /**
     * 添加平台管理员登录后路由
     */
    addPlatformRoutes({commit}) {
      commit('SET_ROUTES', platformRoutes)
      router.addRoutes(formatRoutes(platformRoutes))
    },
    /**
     * 添加租户登录后路由
     */
    addManageRoutes({commit, state}) {
      const routes = handleRouteByUserRole(manageRoutes, state.userInfo.userRole)
      commit('SET_ROUTES', routes)
      router.addRoutes(formatRoutes(routes))
    },
    /**
     * 添加医生登录后路由
     */
    addDoctorRoutes({commit}) {
      commit('SET_ROUTES', doctorRoutes)
      router.addRoutes(formatRoutes(doctorRoutes))
    },
    /**
     * 登录(拼图验证码)
     */
    jigsawCaptchaLogin({commit, state, dispatch}, form) {
      return new Promise((resolve, reject) => {
        captchaLogin(form)
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              // commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
            }
            resolve(respData)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登录(拼图验证码) 手机号登录
     */
    jigsawCaptchaPhoneLogin({commit, state, dispatch}, form) {
      return new Promise((resolve, reject) => {
        phoneCaptchaLogin(form)
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              // commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
            }
            resolve(respData)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登出
     */
    LogOut() {
      return new Promise((resolve, reject) => {
        loginOut().then(() => {
          clearState()
          clearStore()
          removeToken()
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    /**
     * 清除缓存
     */
    FedLogOut({commit}) {
      return new Promise((resolve) => {
        // 清除用户信息
        commit('SET_USER_INFO', {})
        commit('SET_ACCESS_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        // clearStore()
        removeToken()
        resolve()
      })
    },
    /**
     * 刷新用户信息
     */
    refreshUserInfo({commit, state, dispatch}) {
      getSystemUserInfo().then(({data}) => {
        if (data.code === 0) {
          commit('SET_USER_INFO', data.data)
        }
      })
    },
    /**
     * 刷新平台人员信息
     */
    refreshPlatformUserInfo({commit, state, dispatch}) {
      getPlatformUserInfo().then(({data}) => {
        if (data.code === 0) {
          commit('SET_USER_INFO', data.data)
        }
      })
    },
    /**
     * 刷新医生信息
     */
    refreshDoctorInfo({commit, state, dispatch}) {
      getDoctorInfo().then(({data}) => {
        if (data.code === 0) {
          commit('SET_USER_INFO', data.data)
        }
      })
    },
    /**
     * 刷新租户信息
     */
    refreshTenantInfo({commit}) {
      getTenantInfo(getNameCode(), true).then(({data}) => {
        if (data.code === 0) {
          commit('SET_TENANT_INFO', data.data)
          replaceDocumentIconAndTitle()
        } else {
          router.replace('/404')
        }
      }).catch(() => {
        router.replace('/404')
      })
    },
    // 刷新药材信息
    refreshHerbsInfo({commit, state}) {
      commit('REFRESH_HERBS_INFO', state.herbsInfo)
    },
    // 刷新his药材信息
    refreshHisHerbsInfo({commit, state}, hisDeptCode) {
      commit('REFRESH_HIS_HERBS_INFO', {hisHerbsInfo: state.hisHerbsInfo, hisDeptCode: hisDeptCode})
    },
    // 刷新药材单位转换配置
    refreshHerbUnitConvert({commit, state}) {
      commit('REFRESH_HERB_UNIT_CONVERT', state.herbUnitConvert)
    },
    // 刷新his项目库信息
    refreshHisProjectInfo({commit, state}) {
      commit('REFRESH_HIS_PROJECT_INFO', state.hisProjectInfo)
    },
    // 刷新药材克制信息
    refreshHerbsRestraintInfo({commit, state}) {
      commit('REFRESH_HERBS_RESTRAINT_INFO', state.herbsRestraintInfo)
    },
    // 刷新处方配置项信息
    refreshOptionData({commit, state}) {
      commit('REFRESH_OPTION_DATA', state.optionData)
    },
    // 刷新HIS配置信息
    refreshHisOption({commit, state}) {
      commit('REFRESH_HIS_OPTION', state.hisOption)
    },
    // 刷新症状库
    refreshSymptoms({commit, state}) {
      commit('REFRESH_SYMPTOMS', state.symptoms)
    },
    // 刷新诊所收费配置
    refreshFeeConfig({commit, state}) {
      commit('REFRESH_REE_CONFIG', state.feeConfig)
    }
  },
  mutations: {
    /**
     * 刷新token
     */
    REFRESH_TOKEN: (state, token) => {
      refreshToken({refresh_token: Cookies.get('refresh_token')}).then((response) => {
        let data = response.data
        if (data && data.code === 0) {
          // 保存token到store和cookie
          store.commit('SET_ACCESS_TOKEN', data.data.access_token)
          // 保存refresh_token
          store.commit('SET_REFRESH_TOKEN', data.data.refresh_token)
        }
      })
    },

    /**
     * 保存路由
     */
    SET_ROUTES: (state, routes) => {
      state.routes = routes
      setStore({
        name: 'routes',
        content: state.routes
      })
    },
    /**
     * 保存左侧菜单
     */
    SET_MENUS: (state, menus) => {
      state.menus = menus
      setStore({
        name: 'menus',
        content: state.menus
      })
    },
    /**
     * 设置access_token
     */
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.access_token = accessToken
      setToken(accessToken)
      setStore({
        name: 'access_token',
        content: state.access_token
      })
    },

    /**
     * 设置refresh_token
     */
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken
      Cookies.set('refresh_token', rfToken)
      setStore({
        name: 'refresh_token',
        content: state.refresh_token
      })
    },
    /**
     * 设置用户信息
     */
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: 'userInfo',
        content: state.userInfo
      })
    },
    /**
     * 设置诊所信息
     */
    SET_CLINIC_INFO: (state, clinicInfo) => {
      state.clinicInfo = clinicInfo
      setStore({
        name: 'clinicInfo',
        content: state.clinicInfo
      })
    },
    /**
     * 设置租户信息
     */
    SET_TENANT_INFO: (state, tenantInfo) => {
      state.tenantInfo = tenantInfo
      setStore({
        name: 'tenantInfo',
        content: state.tenantInfo
      })
    },
    /**
     * 设置租户配置
     */
    SET_TENANT_CONFIG: (state, tenantConfig) => {
      state.tenantConfig = tenantConfig
      setStore({
        name: 'tenantConfig',
        content: state.tenantConfig
      })
    },
    /**
     * 设置登录类型
     */
    SET_LOGIN_TYPE: (state, loginType) => {
      state.loginType = loginType
      setStore({
        name: 'loginType',
        content: state.loginType
      })
    },
    /**
     * 获取费用配置信息
     */
    REFRESH_REE_CONFIG: (state, feeConfig) => {
      // 获取费用配置信息
      getClinicAllFeeConfig().then(res => {
        const {code, data} = res.data || []
        if (code === 0) {
          state.feeConfig = data
          setStore({
            name: 'feeConfig',
            content: state.feeConfig
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    /**
     * 刷新药材信息
     */
    REFRESH_HERBS_INFO: (state, herbsInfo) => {
      // 获取所有药材
      findAllHerbs().then(res => {
        const {code, data} = res.data || []
        if (code === 0) {
          state.herbsInfo = data.map(e => {
            // 处理首字母
            let initial = e.initial
            const aliasInitial = e.anotherName ? getPinyin(e.anotherName, ' ') : null
            // 没有别名的时候前台再尝试处理
            if (e.pinyin && !initial) {
              initial = e.pinyin.split(' ').map(l => l.substring(0, 1)).join('')
            }
            return {
              dosageCeil: e.dosageCeil,
              herbName: e.herbName,
              virulence: e.virulence,
              unit: e.unit,
              pinyin: e.pinyin,
              initial: initial,
              trait: e.trait,
              alias: e.anotherName,
              aliasPy: aliasInitial,
              majorFunction: e.majorFunction,
              medicineUsage: e.medicineUsage
            }
          })
          setStore({
            name: 'herbsInfo',
            content: state.herbsInfo
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    /**
     * 药材转换
     * @param state
     * @param unitConvert
     * @constructor
     */
    REFRESH_HERB_UNIT_CONVERT: (state, unitConvert) => {
      getUnitConvertConfig().then(res => {
        const {code, data} = res.data || []
        if (code === 0) {
          state.herbUnitConvert = data
          setStore({
            name: 'herbUnitConvert',
            content: state.herbUnitConvert
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    /**
     * 刷新his药材信息
     */
    REFRESH_HIS_HERBS_INFO: (state, params) => {
      let hisDeptCode = params.hisDeptCode
      // 获取所有药材
      findAllHisHerbs(hisDeptCode || '').then(res => {
        const {code, data} = res.data || []
        if (code === 0) {
          state.hisHerbsInfo = data.map(e => {
            // 处理首字母 将药材名称和别名的拼音首字母合成这一个字段
            let initial = ''
            if (e.pinyin) {
              e.pinyin = e.pinyin.toLowerCase()
              initial = e.pinyin.split(' ').map(l => l.substring(0, 1)).join('')
            }
            return {
              initial: initial,
              id: e.id,
              hosName: e.hosName,
              hosCode: e.hosCode,
              deptName: e.deptName,
              deptCode: e.deptCode,
              mediName: e.mediName,
              mediCode: e.mediCode,
              pinyin: e.pinyin,
              specification: e.specification,
              unit: e.unit,
              origin: e.origin,
              typeName: e.typeName,
              price: e.price,
              store: e.store,
              encaseTimes: e.encaseTimes,
              encaseUnit: e.encaseUnit,
              editTime: e.editTime
            }
          })
          setStore({
            name: 'hisHerbsInfo',
            content: state.hisHerbsInfo
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    /**
     * 刷新his项目信息
     */
    REFRESH_HIS_PROJECT_INFO: (state, hisHProjectInfo) => {
      // 获取his项目库信息
      allPrescriptionProject().then(res => {
        let resData = res.data
        if (resData && resData.code === 0) {
          state.hisProjectInfo = resData.data
          setStore({
            name: 'hisProjectInfo',
            content: state.hisProjectInfo
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    /**
     * 刷新药材克制关系信息
     */
    REFRESH_HERBS_RESTRAINT_INFO: (state, herbsRestraintInfo) => {
      // 获取所有药材克制关系
      findAllHerbsRestraint().then(res => {
        const {code, data} = res.data
        if (code === 0) {
          // 转换药材克制关系
          state.herbsRestraintInfo = data || []
          setStore({
            name: 'herbsRestraintInfo',
            content: state.herbsRestraintInfo
          })
          // 同步构建配伍禁忌的索引
          state.herbsRestraintInfoIndex = buildHerbRelationsIndex(state.herbsRestraintInfo || [])
          setStore({
            name: 'herbsRestraintInfoIndex',
            content: state.herbsRestraintInfoIndex
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    /**
     * 刷新处方配置项信息
     */
    REFRESH_OPTION_DATA: (state) => {
      optionData().then((res) => {
        const {code, data} = res.data
        if (code === 0 && data) {
          const result = data || {
            chineseOptions: '',
            granuleOptions: '',
            ingredientOptions: ''
          }
          if (!result.chineseOptions) {
            result.chineseOptions = JSON.stringify({
              usage: [],
              requirement: [],
              herbUsage: [],
              unit: []
            })
          }
          if (!result.granuleOptions) {
            result.granuleOptions = JSON.stringify({
              usage: [],
              requirement: [],
              unit: []
            })
          }
          if (!result.ingredientOptions) {
            result.ingredientOptions = JSON.stringify({
              usage: [],
              unit: [],
              frequency: []
            })
          }
          state.optionData = result
          setStore({
            name: 'optionData',
            content: state.optionData
          })
        }
      })
    },
    /**
     * 刷新 his 配置
     */
    REFRESH_HIS_OPTION: (state) => {
      hisOption().then(res => {
        const {code, data} = res.data
          if (code === 0) {
            state.hisOption = data
            setStore({
              name: 'hisOption',
              content: state.hisOption
            })
          }
      })
    },
    /**
     * 刷新症状库数据
     */
    REFRESH_SYMPTOMS: (state) => {
      findAllSymptoms().then(res => {
        const {code, data} = res.data || []
        if (code === 0) {
          state.symptoms = data
          setStore({
            name: 'symptoms',
            content: state.symptoms
          })
        }
      })
    }
  }
}

/**
 * 提取药材配伍禁忌索引
 * 多个药材 与多个药材之间的关系提取成单个 单个药材对应着多个配伍禁忌
 * @param herbRelations
 */
const buildHerbRelationsIndex = (herbRelations) => {
  const index = {}

  herbRelations.forEach(rule => {
    const herbs1 = (rule.herbName1 || '').split(/[，,、]/).map(item => item.trim()).filter(Boolean)
    const herbs2 = (rule.herbName2 || '').split(/[，,、]/).map(item => item.trim()).filter(Boolean)

    const normalizedRule = {
      herbs1,
      herbs2,
      relation: String(rule.relation || '').trim()
    }

    // herbName1 -> rule
    herbs1.forEach(herb => {
      if (!index[herb]) {
        index[herb] = []
      }
      index[herb].push(normalizedRule)
    })

    // 反方向匹配 herbName2 -> rule
    herbs2.forEach(herb => {
      if (!index[herb]) {
        index[herb] = []
      }
      index[herb].push(normalizedRule)
    })
  })

  return index
}

export default login

/**
 * 重置store里所有数据
 */
export const clearState = function () {
  let initState = deepClone(window.initState)
  store.state.app = initState.app
  store.state.login = initState.login
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js